




















































import { Component, Prop, Inject } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import insertText from "insert-text-textarea";
import { getModule } from "vuex-module-decorators";
import autosize from "v-autosize";

import FormField from "@/lib/components/FormField.vue";
import FormErrors from "@/lib/components/FormErrors.vue";
import SubmitButton from "@/lib/components/SubmitButton.vue";

import preloadImage from "@/lib/preload-image.function";
import autoindent from "@/lib/directives/auto-indent.directive";
import GeneralFormMixin from "@/lib/mixins/GeneralForm";
import dataStore from "@/store";
import ImageHandlerService from "@/modules/file-storage/image-handler.service";
import IdGenerator from "@/lib/services/id-generator";
import Item from "@/modules/file-storage/item.model";

import MessageAttachmentUpload from "./MessageSendingForm/AttachmentUpload.vue";
import MessagesSendingFormEmojiPicker from "./EmojiPicker.vue";

import MessagingStore from "../store";
import { ChannelValue } from "../channel.value";
import getAttachmentThumbnail from "../get-attachment-thumbnail.function";

@Component({
  components: {
    FormField,
    FormErrors,
    MessageAttachmentUpload,
    SubmitButton,
    MessagesSendingFormEmojiPicker,
  },
  directives: {
    autoindent,
    autosize,
  },
})
export default class MessageSendingForm extends mixins(GeneralFormMixin) {
  @Prop({ required: true })
  public readonly plushieId!: string;

  @Inject("IdGenerator")
  private fIdGenerator!: IdGenerator;

  @Inject("ImageHandlerService")
  private fImageHandlerService!: ImageHandlerService;

  public message?: string;

  private fAttachmentStorageItemsData: Pick<Item, "mime" | "id">[] = [];
  private fIsAttachmentsProcessingInProgress = false;

  private fMessagingDataStore: MessagingStore;

  get isAttachmentsProcessingInProgress(): boolean {
    return this.fIsAttachmentsProcessingInProgress;
  }

  get isDisabled(): boolean {
    return (
      this.isAttachmentsProcessingInProgress || this.fIsDisabled || this.disable
    );
  }

  get isUploadDisabled(): boolean {
    return this.fIsDisabled || this.disable;
  }

  constructor() {
    super();
    this.fMessagingDataStore = getModule(MessagingStore, dataStore);
  }

  browseFiles() {
    const imageUpload = this.getAttachmentUpload();
    if (!imageUpload) {
      return;
    }

    imageUpload.browseFiles();
  }

  onEmojiPicked(emoji: string): void {
    const messageInput = this.getMessageInput();

    if (!messageInput) {
      return;
    }

    messageInput.focus();

    insertText(messageInput, emoji);
  }

  public onAttachmentAdded(storageItem: Item): void {
    this.fAttachmentStorageItemsData.push({
      id: storageItem.id,
      mime: storageItem.mime,
    });

    const thumbUrl = getAttachmentThumbnail(
      storageItem.url,
      this.fImageHandlerService
    );

    void preloadImage(thumbUrl);
  }

  public onAttachmentRemoved(storageItemId: string): void {
    const index = this.fAttachmentStorageItemsData.findIndex(
      (item) => item.id === storageItemId
    );

    if (index > -1) {
      this.fAttachmentStorageItemsData.splice(index, 1);
    }
  }

  public onAttachmentIsBusyChanged(value: boolean): void {
    this.fIsAttachmentsProcessingInProgress = value;
  }

  protected async afterSubmit(): Promise<void> {
    this.$nextTick(() => {
      const messageInput = this.getMessageInput();
      if (!messageInput) {
        return;
      }

      messageInput.focus();
    });
  }

  protected data() {
    return {
      message: this.message,
    };
  }

  protected async performSubmit(): Promise<void> {
    if (!this.message) {
      return;
    }

    await this.fMessagingDataStore.createMessage({
      id: this.fIdGenerator.getId(),
      channel: ChannelValue.STORE_CUSTOMER,
      plushie: this.plushieId,
      text: this.message,
      attachments: this.fAttachmentStorageItemsData,
    });

    this.message = "";

    const imageUpload = this.getAttachmentUpload();
    if (!imageUpload) {
      return;
    }

    this.fAttachmentStorageItemsData = [];
    imageUpload.clearInput();
  }

  private getAttachmentUpload(): MessageAttachmentUpload | undefined {
    return this.$refs["attachment-upload"] as MessageAttachmentUpload;
  }

  private getMessageInput(): HTMLTextAreaElement | undefined {
    return this.$refs["message-input"] as HTMLTextAreaElement;
  }
}
